import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Obgyn icon
 *
 * @category Medical
 */
const Obgyn = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.327 13.811c-.3-1.6-.62-3.22-1.3-4.7s-1.84-2.92-3.38-3.58c-.25-.11-.58-.17-.74.04-.21.29.14.65.44.85 1.99 1.31 3.35 3.53 3.62 5.9.08.66.07 1.34.32 1.96.09.22.21.44.21.68 0 .18-.08.36-.15.52-.53 1.17-1.12 2.33-1.95 3.3s-1.94 1.76-3.2 2.01c-.73.14-1.58.06-2.09-.49-.17-.18-.35-.42-.58-.37-.34.07-.28.58-.13.89.88 1.88 1.75 3.75 2.63 5.63-3 .02-5.99.04-8.99.05-.39 0-.8 0-1.14-.19-.32-.17-.53-.48-.71-.79-.95-1.64-1.14-3.66-.68-5.5.79-3.19 3.4-5.79 3.78-9.05.17-1.49-.16-3.03-.92-4.32-.17-.29-.72-1.19-1.15-1.11-.63.11-.03 1.19.15 1.48.42.69.78 1.44.93 2.24.32 1.68-.31 3.4-1.12 4.9s-1.83 2.91-2.4 4.53c-.91 2.58-.55 5.57.95 7.86.21.32.46.65.82.8.28.12.59.12.89.12h13.74c.36 0 .79-.04.95-.37.14-.29-.03-.63-.21-.91-.92-1.48-1.85-2.96-2.77-4.44-.06-.09-.12-.19-.12-.3 0-.23.23-.38.43-.5 1.57-.91 2.54-2.55 3.44-4.13.24-.41.47-.84.56-1.31.1-.53 0-1.06-.1-1.59 0-.05-.02-.09-.03-.14zm-2.47 12.64c-.65.03-1.83.08-2.47-.04-.71-.39-.88-1.38-1.38-2.13-.33-.66-.73-1.37-.9-1.97-.07-.53.46-.51.93-.6.32-.06.6-.08.8.05.59.52 1.04 1.51 1.57 2.22.53.93 1.29 1.73 1.5 2.43l-.06.04z"
        />
      </svg>
    );
  }
);

Obgyn.displayName = 'Obgyn';

export { Obgyn };
